module.exports = __webpack_public_path__ + "static/media/spotify.8356e6c7.png";